/* ABC: поиск раскрывается прямо в шапке — в свободном месте между меню
   и иконками, лупа остаётся ровно там же, где и была.

   Ширину поля считаем по факту: от правого края последнего пункта меню
   до правого края лупы. Добавится пункт (например SALE) — поле само
   станет короче, ничего править не надо.

   У кнопки поиска Horizon свой декларативный обработчик
   on:click="#search-modal/showDialog" — он ловится делегированием темы
   раньше наших слушателей, поэтому одного stopPropagation мало:
   модалка всё равно открывалась. Снимаем сам атрибут и вешаем своё. */
(function () {
  var GAP = 20;            // отступ от последнего пункта меню до поля

  function form()    { return document.querySelector('[data-abc-search]'); }
  function overlay() { return document.querySelector('[data-abc-search-overlay]'); }
  function panel()   { return document.querySelector('[data-abc-suggest]'); }
  function headerSection() { return document.querySelector('[id*="header_section"]'); }
  function columns() { return document.querySelector('.header__columns'); }
  function isOpen()  { var f = form(); return !!(f && f.classList.contains('is-open')); }

  /* видимая (не мобильная) кнопка-лупа в шапке */
  function searchButton() {
    var list = document.querySelectorAll('search-button');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return list[i];
    }
    return null;
  }

  /* правый край меню: берём верхний уровень, подменю в расчёт не идут —
     их панели шире самого меню и ломали замер */
  function menuRight() {
    var col = document.querySelector('.header__column--left');
    if (!col) return null;
    var box = col.getBoundingClientRect();
    var top = col.querySelector('menu-list, header-menu, .menu-list');
    var max = box.left;
    if (top) {
      var r = top.getBoundingClientRect();
      if (r.width > 0) max = Math.max(max, r.right);
    }
    /* бургер на мобильном — тоже левый край поля */
    var burger = col.querySelector('.header__icon--menu, button');
    if (burger) {
      var br = burger.getBoundingClientRect();
      if (br.width > 0 && br.height > 0) max = Math.max(max, br.right);
    }
    return max;
  }

  /* форма и панель должны жить в шапке: форма — внутри строки с колонками,
     панель — прямо в секции, чтобы падать под шапку во всю ширину */
  function mount() {
    var f = form(), p = panel(), cols = columns(), sec = headerSection();
    if (f && cols && f.parentElement !== cols) cols.appendChild(f);
    if (p && sec && p.parentElement !== sec) sec.appendChild(p);
  }

  function place() {
    var f = form(), cols = columns(), btn = searchButton();
    if (!f || !cols || !btn) return;
    var box = cols.getBoundingClientRect();
    var left = menuRight();
    var right = btn.getBoundingClientRect().right;
    /* ABC 29.09: кнопка валюты «EUR €» (V1) стоит перед лупой — поле заканчивается перед ней, не накрывает */
    var cc = document.querySelector('.abc-cc-hdr');
    if (cc) {
      var cr = cc.getBoundingClientRect();
      if (cr.width > 0 && cr.left > left) { right = cr.left - GAP; f.style.paddingRight = '0px'; }
      else f.style.paddingRight = '';
    }
    if (left == null || !(right > left)) return;
    f.style.left = (left - box.left + GAP) + 'px';
    var w = right - left - GAP;
    f.style.width = w + 'px';
  }

  function open() {
    var f = form();
    if (!f) return;
    mount();
    f.classList.add('is-open');
    place();
    document.documentElement.classList.add('abc-search-open');
    showOverlay();
    var i = f.querySelector('.abc-search__input');
    if (i) { i.focus(); i.select(); }
    closeThemeModal();
  }

  function close() {
    var f = form();
    if (f) f.classList.remove('is-open');
    document.documentElement.classList.remove('abc-search-open');
    var sg = panel();
    if (sg) sg.hidden = true;
    var sl = document.querySelector('[data-abc-suggest-list]');
    if (sl) sl.innerHTML = '';
    hideOverlay();
  }

  /* затемнение появляется и уходит плавно: сначала снимаем hidden,
     потом на следующем кадре включаем прозрачность — иначе перехода нет */
  function showOverlay() {
    var o = overlay(), sec = headerSection();
    if (sec) sec.classList.add('abc-search-lifted');
    if (!o) return;
    o.hidden = false;
    requestAnimationFrame(function () { o.classList.add('is-visible'); });
  }
  function hideOverlay() {
    var o = overlay(), sec = headerSection();
    var drop = function () { if (sec) sec.classList.remove('abc-search-lifted'); };
    if (!o) { drop(); return; }
    o.classList.remove('is-visible');
    var done = function () {
      o.hidden = true;
      drop();
      o.removeEventListener('transitionend', done);
    };
    o.addEventListener('transitionend', done);
    setTimeout(done, 300);
  }

  function closeThemeModal() {
    var d = document.querySelector('#search-modal dialog[open]');
    if (d) d.close();
  }

  function disarm() {
    document.querySelectorAll('search-button button[on\\:click]').forEach(function (b) {
      b.removeAttribute('on:click');
      if (b.dataset.abcBound) return;
      b.dataset.abcBound = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!isOpen()) { open(); return; }
        /* поиск уже открыт: если в поле что-то набрано — лупа отправляет
           запрос, как Enter; если пусто — просто закрываем */
        var f = form();
        var i = f && f.querySelector('.abc-search__input');
        if (i && i.value.trim()) { f.submit(); return; }
        close();
      });
    });
  }

  function boot() { mount(); disarm(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // шапка может перерисовываться (например, при смене секции в редакторе)
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', function () { if (isOpen()) place(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  document.addEventListener('pointerdown', function (e) {
    if (!isOpen()) return;
    if (e.target.closest && (e.target.closest('[data-abc-search]') ||
        e.target.closest('[data-abc-suggest]') ||
        e.target.closest('search-button'))) return;
    close();
  }, true);
})();
